import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import store from "./redux/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { isLocalEnvironment } from "./utils/constants";
import { StyledEngineProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./components/style.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: true,
    },
  },
});

const AppTree = (
  <StyledEngineProvider injectFirst>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <CssBaseline />
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </StyledEngineProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  isLocalEnvironment() ? (
    <React.StrictMode>{AppTree}</React.StrictMode>
  ) : (
    AppTree
  )
);
